// extracted by mini-css-extract-plugin
module.exports = {"unauthorised":"Unauthorised_unauthorised__36Yqw","container":"Unauthorised_container__1Bvei","subHeading":"Unauthorised_subHeading__1ZLWg"};